import props from './props'
export default {
  name: 'form-item-render',
  functional: true,
  mixins: [props],
  render: (h, ctx) => {
    const { item, formItems, readonly } = ctx.props
    return item.render(h, item, formItems, readonly)
  }
}
